import './category.styles';

import microTemplate from '@/scripts/lib/microTmpl';

import { formatDate, getDirectusHeaders, getTemplateData, getThumbnail, makeSrcset } from '@/scripts/utils/cms';
import { preprocessApiException } from '@/scripts/utils/api';
import initBlogLayout from '@/layouts/blog/blog-layout';
import initPage from '@/scripts/init/init';
import ImgLazyLoad from '@/scripts/lib/ImgLazyLoad';
import SpinBtn from '@/components/SpinBtn';

import postTmpl from './templates/post.html';
import AlertModal from '@/components/AlertModal/AlertModal';
import { MOD_TEXTS } from '@/scripts/common/textMsg';
import initNewsletters from '@/templates/newsletters/newsletters';

const $page = document.querySelector('.category-js');

const curCategory = getTemplateData('curCategory');

initPage();
initBlogLayout();
new ImgLazyLoad(document.querySelectorAll('img.lazy'));

const alert = new AlertModal();

(function loadMore() {
   const $postsList = $page.querySelector('.posts-list-js');
   const $moreBtn = $page.querySelector('.more-js');
   if (!$moreBtn) return;

   const moreBtn = window.btn = new SpinBtn($moreBtn, { checkIcon: false });

   const topPosts = 4;
   const pageSize = 4;
   let page = 0;

   $moreBtn.addEventListener('click', () => {
      loadNextPage();
   });

   async function loadNextPage() {
      moreBtn.startLoading();

      try {
         const resp = await fetchPage(page + 1);
         renderPage(resp.data);
         page++;

         if (resp.meta.filter_count <= renderedPosts()) {
            hideMoreBtn();
         }

      } catch (e) {
         if (typeof e !== 'string') throw e;
         await moreBtn.stopLoading(false);
         alert.show({ title: MOD_TEXTS.ErrTitle, msg: e });
      }

      moreBtn.stopLoading(true);
   }

   /** @param {Post[]} posts */
   function renderPage(posts) {
      const html = posts.map(p => makeTmplConfig(p))
         .map(p => microTemplate(postTmpl, p)).join('');

      $postsList.insertAdjacentHTML('beforeend', html);
   }

   /** @returns {Promise<DirectusResponse<Post[]>>} */
   async function fetchPage(page) {
      try {
         const resp = await fetch(buildUrl(page), { 
            headers: getDirectusHeaders(),
         });
         if (!resp.ok) throw resp;
         return resp.json();
      } catch (e) {
         await preprocessApiException(e);
      }
   }

   function buildUrl(page) {
      const fields = [
         'slug', 'title', 'excerpt',
         'type', 'published_on',
         'post_category.*',
         'post_author.*',
         'main_image.data.*',
      ];

      const url = new URL(`${process.env.API}/items/posts`);
      url.searchParams.set('meta', '*');
      url.searchParams.set('fields', fields.join(','));
      url.searchParams.set('filter[post_category.slug][in]', curCategory);
      url.searchParams.set('sort', '-published_on');
      url.searchParams.set('offset', topPosts + page * pageSize);
      url.searchParams.set('limit', pageSize);
      return url;
   }

   function makeTmplConfig(post) {
      return { post, formatDate, getThumbnail, makeSrcset };
   }

   function renderedPosts() {
      return (page + 1) * pageSize + topPosts;
   }

   function hideMoreBtn() {
      $moreBtn.classList.add('all-posts--more__hidden');
   }
}());

(function newsletters() {
   const parent = $page.querySelector('.newsletters-parent-js');
   initNewsletters(parent);
}());

(function setHumEvents(){
   if (!window.humTracker) return;
   
   humTracker.trackScroll($page, 'category scroll');
   humTracker.trackClick($page.querySelector('.more-js'), 'load more click');
}());